export function OfferProgressSteps({ activeStep }: { activeStep: number }) {
  return (
    <div className="offer-campaign-steps" aria-label="Offer campaign workflow steps">
      {['MRN', 'Eligibility', 'Offer Code', 'Advance', 'Coupon'].map((label, index) => (
        <div key={label} className={index <= activeStep ? 'active' : ''}>
          <span>{index + 1}</span>
          <strong>{label}</strong>
        </div>
      ))}
    </div>
  );
}
